import { render, staticRenderFns } from "./manage-name.vue?vue&type=template&id=b597990c&scoped=true"
import script from "./manage-name.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-name.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./manage-name.vue?vue&type=style&index=0&id=b597990c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b597990c",
  null
  
)

export default component.exports